import React, { useState, useEffect } from 'react';
import { callApi } from 'src/core/callApi';
import { User } from 'src/interfaces/iuser';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInfo } from 'src/store/Dashboard/actions';

export const useUserAffiliateInfo = (partnerKey: string) => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.dashboard.user);
  const [userAffiliateInfo, setUserAffiliateInfo] = useState<any>('loading');
  const [error, setError] = useState<string>('');

  const fetchUserAffiliateInfo = async () => {
    setError('');
    setUserAffiliateInfo('loading');

    const url =
      'https://ak27jez2w0.execute-api.us-east-2.amazonaws.com/default/affiliatePartnerStats';

    const config: any = {
      queryParams: {
        isKeyEmail: true,
        operationType: 'retrieve',
        affiliateStatsType: 'v2'
      },
    };
    if (partnerKey) {
      config.queryParams.affiliateKey = partnerKey;
      config.queryParams.affiliatePartnerPassword = encodeURIComponent(
        localStorage.getItem('AffiliatePartnerPassword') || ''
      );
      delete config.queryParams.isKeyEmail;
    }

    const response = await callApi(url, config, true, false, '', 'GET', true);
    if (response?.data) {
      setUserAffiliateInfo(response.data);
    } else if (response?.error) {
      setUserAffiliateInfo(null);
      setError(response.error);
    } else {
      setUserAffiliateInfo(null);
      setError('no-affiliate');
    }
  };

  useEffect(() => {
    dispatch(getUserInfo());
  }, []);

  useEffect(() => {
    if (user && user.email && user.email.toLowerCase() !== 'trial') {
      fetchUserAffiliateInfo();
    }
  }, [user]);

  return { userAffiliateInfo, affiliateKey: partnerKey || user?.affiliateKey, error };
};

export const useCreateAffiliateLink = () => {
  const [isCreateAffiliateLinkLoading, setIsCreateAffiliateLinkLoading] = useState<boolean>(false);
  const [createAffiliateLinkError, setCreateAffiliateLinkError] = useState<string>('');


  const createAffiliateLink = async () => {
    setIsCreateAffiliateLinkLoading(true);
    setCreateAffiliateLinkError('');

    const url =
      'https://a8q9o0b2r3.execute-api.us-east-2.amazonaws.com/default/createAffiliatePartner';

    try {
      const response = await callApi(url, {queryParams: {}}, true, false, '', 'GET', true);
      console.log('response: ', response);
      if (response?.affiliate_key) {
        window.location.reload();
      } else if (response?.error?.message) {
        setCreateAffiliateLinkError(response?.error?.message);
      } else if (response?.error) {
        setCreateAffiliateLinkError(response?.error || 'Failed to create affiliate link.');
      }
    } catch (error) {
      setCreateAffiliateLinkError('Failed to create affiliate link.');
    }
    setIsCreateAffiliateLinkLoading(false);
  };

  return {
    isCreateAffiliateLinkLoading,
    createAffiliateLinkError,
    createAffiliateLink,
  };
};
